import { createCheckoutService } from '@bigcommerce/checkout-sdk';
import { getLanguageService } from  '@bigcommerce/checkout/locale';
import axios from 'axios'
import envConfig from '../app/b3checkout/request/envConfig'
import Swal from 'sweetalert2'

declare const B2B_ENV: string;
class B3loader {
  [x: string]: any;
  constructor() {
    this.storeHash = ''
    this.b3request = null
    this.checkoutService = null
    this.checkoutUrl = ''
    this.channelId = 0
    this.checkoutDefaultUrl = 'https://cdn.bundleb2b.net/prod/checkout-latest/auto-loader-1.0.0.js'
    this.init()
  }

  async init() {
    let currentB2BEnabled = sessionStorage.getItem('currentB2BEnabled')
    currentB2BEnabled = currentB2BEnabled ? JSON.parse(currentB2BEnabled) : ''

    if (window.location.pathname !== '/checkout/order-confirmation') {
      this.initCreateCheckoutService()
      this.initAxios()
      await this.getStoreHash()

      if (!currentB2BEnabled) {
        currentB2BEnabled = await this.getStoreSites()
      }
    }


    if (!currentB2BEnabled) {
      this.checkoutUrl = 'https://cdn11.bigcommerce.com/shared/microapp/checkout/dist/auto-loader-1.470.3.js';
      this.setBCConfigPublicPath()
      this.mount()
    } else {
      try {
        if (!this.isCompletePayment()) {
          await this.getCheckoutUrl()
          this.setConfigPublicPath()
          this.mount()
        }
      } catch (err) {
        console.log(err)
        this.mount()
      }
    }
  }

  async getStoreSites() {
    const getStoreChannelId = () => `{
      storeBasicInfo(storeHash: "${this.storeHash}"){
        multiStorefrontEnabled
        storeSites{
          channelId
          isEnabled
          b2bEnabled
          b3ChannelId
        }
      }
    }`

    let isEnabled = ''

    try {
      const data = await this.b3request.post('/graphql', {
        query: getStoreChannelId()
      })

      if (data.status === 200) {
        const {
          data: {
            data: {
              storeBasicInfo: {
                storeSites,
                multiStorefrontEnabled = false,
              },
            }
          }
        } = data

        const currentB2BShop = storeSites.find((item: any) => +item.channelId === +this.channelId) || ''
        if (currentB2BShop) {
          isEnabled = multiStorefrontEnabled
          ? `${currentB2BShop.b2bEnabled}: true : ''`
          : 'true'
        }
      }
    } finally {
      return isEnabled
    }
  }


  isCompletePayment() {
    const {
      orderId,
    } = (window as any).checkoutConfig;
    if (location.pathname === '/checkout/order-confirmation' || orderId) {
      const url: any = sessionStorage.getItem('checkoutConfirmation')
      if ((window as any)?.checkoutConfig?.publicPath) {
        (window as any).checkoutConfig.publicPath = url.includes('auto-loader.js') ? url.split('auto-loader.js')[0] : url.split('auto-loader-1.0.0.js')[0]
      } else {
        (window as any).checkoutB3Config.publicPath = url.includes('auto-loader.js') ? url.split('auto-loader.js')[0] : url.split('auto-loader-1.0.0.js')[0]
      }
      const el = document.createElement('script');
      el.setAttribute('src', url);
      (document as any).querySelector('body').append(el);
      return true;
    }
    return false;
  }
  setConfigPublicPath() {
    if (!this.checkoutUrl) return
    if ((window as any)?.checkoutConfig?.publicPath) {
      (window as any).checkoutConfig.publicPath = this.checkoutUrl.includes('auto-loader.js') ? this.checkoutUrl.split('auto-loader.js')[0] : this.checkoutUrl.split('auto-loader-1.0.0.js')[0]
    } else {
      (window as any).checkoutB3Config.publicPath = this.checkoutUrl.includes('auto-loader.js') ? this.checkoutUrl.split('auto-loader.js')[0] : this.checkoutUrl.split('auto-loader-1.0.0.js')[0]
    }
  }

  setBCConfigPublicPath() {
    if (!this.checkoutUrl) return
    if ((window as any)?.checkoutConfig?.publicPath) {
      (window as any).checkoutConfig.publicPath = this.checkoutUrl.split('auto-loader')[0]
    } else {
      (window as any).checkoutB3Config = {
        publicPath: this.checkoutUrl.split('auto-loader')[0]
      }
    }
  }

  mount() {
    const el = document.createElement('script');
    el.setAttribute('src', this.checkoutUrl || this.checkoutDefaultUrl);
    sessionStorage.setItem('checkoutConfirmation', this.checkoutUrl || this.checkoutDefaultUrl);
    (document as any).querySelector('body').append(el);
  }

  async getCheckoutUrl() {
    try {
      const { data }: any = await this.b3request.get(`/api/v2/stores/auto-loaders?storeHash=${this.storeHash}&isCheckout=true`)
      if (data.code === 200) {
        const { data: { checkoutUrl } }: any = data
        this.checkoutUrl = checkoutUrl
      } else {
        Swal.fire({
          icon: 'error',
          text: `${data.message}`,
        })
      }
    } catch (error) {
      console.log(error);
    }
   
  }

  async getStoreHash() {
    const {
      checkoutId,
    } = (window as any).checkoutConfig;
    const { data } = await this.checkoutService.loadCheckout(checkoutId, {
      params: {
          include: [
              'cart.lineItems.physicalItems.categoryNames',
              'cart.lineItems.digitalItems.categoryNames',
          ] as any, // FIXME: Currently the enum is not exported so it can't be used here.
      },
    });
    const { storeProfile: { storeHash } }: any = data.getConfig();

    const { channelId }: any = data.getCheckout();
    this.storeHash = storeHash
    this.channelId = channelId
  }

  initCreateCheckoutService() {
    this.checkoutService = createCheckoutService({
      locale: getLanguageService().getLocale(),
      shouldWarnMutation: B2B_ENV === 'development',
    })
  }

  initAxios() {
    const env: string = B2B_ENV || 'production'
    this.b3request = axios.create({
      baseURL: envConfig[env].baseUrl,
      timeout: 1000 * 10 * 60 * 5,
    })
  }
}

new B3loader()